<template>
    <div class="residentdatabase-preview-table" v-show="display">
        <div class="head-controller-box">
            <div class="back-btn" @click="onBack">
                <div class="icon liefeng-icon liefeng-icon-close"></div>
            </div>
            <div class="title-box">预览自定义表单</div>
            <button class="submit-button" @click="onSubmit">
                <div class="icon liefeng-icon liefeng-icon-check"></div>
                <p class="submit">是我想要的，保存</p>
            </button>
        </div>
        <div class="content-box">
            <div class="table-base" v-if="columns">
                <div class="table-box">
                    <Table :columns="columns" :data="tableData"></Table>
                </div>
            </div>

            <div class="operate-box">
                <div class="item-box" @click="onPreviewForm">预览填写效果</div>
                <div class="item-box" @click="onBack">少了字段，返回增加</div>
                <div class="item-box">勾选中缺少我需要的，申请创建</div>
            </div>
        </div>

        <PreviewForm ref="preview_form"></PreviewForm>
    </div>
</template>

<script>
import PreviewForm from "./form.vue"

export default {
    components: { PreviewForm },

    data() {
        return {
            display: false,
            selected: null,

            columns: null,
            tableData: [],
        }
    },

    methods: {
        onDisplay(selected) {
            const columns = []
            const data = {}

            for (let i = 0; i < selected.length; i++) {
                const v = selected[i]

                columns.push({
                    title: v.fieldName,
                    align: "center",
                    minWidth: 120,
                    key: v.fieldId,
                })

                data[v.fieldId] = "-"
            }

            this.columns = columns
            this.tableData = [data]
            this.selected = selected

            this.$nextTick(() => {
                this.display = true
            })
        },
        onBack() {
            this.display = false
        },
        onSubmit() {
            this.$emit("on-submit")
        },

        onPreviewForm() {
            this.$refs.preview_form.onDisplay(this.selected)
        },
    },
}
</script>

<style lang="less">
.residentdatabase-preview-table {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: #fff;

    .head-controller-box {
        width: 100%;
        height: 70px;
        border-bottom: 1px solid #e3e3e3;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        flex-shrink: 0;
        justify-content: space-between;

        > .back-btn {
            position: relative;
            height: 100%;
            cursor: pointer;
            padding: 0 30px;
            display: flex;
            align-items: center;
            justify-content: center;

            &::after {
                position: absolute;
                top: 20px;
                right: 0;
                bottom: 20px;
                content: "";
                width: 1px;
                background: #eee;
            }

            .icon {
                font-size: 26px;
                font-weight: bold;
            }
        }

        .title-box {
            font-size: 20px;
            font-weight: bold;
            flex-grow: 1;
            margin-left: 30px;
        }

        .submit-button {
            cursor: pointer;
            margin: 0 30px;
            height: 40px;
            padding: 0 20px;
            background: #00b3d9;
            border: 1px solid #00b3d9;
            transition: all 0.3s;
            flex-shrink: 0;
            border-radius: 5px;
            display: flex;
            align-items: center;

            &:hover {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
            }

            .icon {
                font-size: 20px;
                color: #fff;
            }

            .submit {
                margin-left: 10px;
                color: #fff;
                font-size: 16px;
            }
        }
    }

    > .content-box {
        width: 100%;
        height: ~"calc(100% - 71px)";

        .table-base {
            padding: 40px 40px 20px 40px;

            .table-box {
                border: 1px solid #e3e3e3;
                border-bottom: 0;
            }
        }

        .operate-box {
            margin: 20px 40px;
            display: flex;
            align-items: center;
            justify-content: center;

            > .item-box {
                cursor: pointer;
                margin: 5px 10px;
                padding: 10px 20px;
                border: 1px solid #e3e3e3;
                background: #fdfdfd;
                color: #333;
                border-radius: 6px;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);

                &.highlight {
                    background: #2faaf7;
                    color: #fff;
                }
            }
        }
    }
}
</style>
